var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Maintain"}},[_c('Spot',{staticStyle:{"margin-top":"78px"},attrs:{"SpotEnTitle":_vm.SpotEnTitle,"SpotZhTitle":_vm.SpotZhTitle}}),_c('div',{staticClass:"vHtml",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }